/**
 * Cel linku „Zobacz wszystkie kategorie” w menu (desktop megamenu + mobilny
 * drawer): kanoniczny URL kategorii root (id=2), renderowany przez
 * [...slug].vue jak każda kategoria. Slug `strona-glowna` zweryfikowany na
 * dev DB 2026-07-03; przed wdrożeniem potwierdź link_rewrite kategorii 2 na
 * prod — to jedyne miejsce korekty.
 */
export const ALL_CATEGORIES_HREF = '/2-strona-glowna'
